module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// /opt/wh/whtree/~/core-js/modules/_iter-step.js
// module id = 783
// module chunks = 0